import React, {FC, ReactNode} from 'react';
import AppContextProvider from "@context/appContext/AppContextProvider";
import AuthContextProvider from '@containers/auth/context/AuthContextProvider';
import BaseAppProvider from "@app/appProvider/baseAppProvider/BaseAppProvider";


interface IProps {
    children: ReactNode
}

const AppProvider: FC<IProps> = ({children}) => {
    return (
        <BaseAppProvider>
            <AuthContextProvider>
                <AppContextProvider>
                    {children}
                </AppContextProvider>
            </AuthContextProvider>
        </BaseAppProvider>
    );
};

export default AppProvider;